import { useMemo } from 'react'
import { useBudgets } from '../hooks/useData'
import { useAuth } from '../hooks/useAuth'
import { useIncome } from '../hooks/useData'
import { getPayCycle, currentPayCycleStart } from '../lib/payday'
import { colors, fonts } from '../components/UI'
import FinancialBlueprint from '../components/FinancialBlueprint'

export default function BlueprintPage() {
  const { profile } = useAuth()
  const payDay = profile?.pay_day
  const shiftWeekends = profile?.pay_day_shift_weekends !== false
  const currentCycle = useMemo(() => getPayCycle(payDay, new Date(), shiftWeekends), [payDay, shiftWeekends])
  const periodKey = currentCycle?.startIso || currentPayCycleStart(payDay, shiftWeekends)
  const { budgets, totalBudgeted } = useBudgets(periodKey)
  const { incomeForCycle } = useIncome()
  const totalIncome = currentCycle ? incomeForCycle(currentCycle) : 0

  return (
    <div style={{ paddingBottom: '32px' }}>
      <div style={{ padding: '18px 20px 16px' }}>
        <div style={{ fontFamily: fonts.heading, fontWeight: 800, fontSize: '22px', color: colors.text, letterSpacing: '-0.01em' }}>
          50/30/20 Blueprint
        </div>
        <div style={{ fontSize: '14px', fontWeight: 500, color: colors.muted, marginTop: '4px' }}>
          How your budget maps to the 50/30/20 rule
        </div>
      </div>
      <div style={{ padding: '0 16px' }}>
        <FinancialBlueprint budgets={budgets} totalIncome={totalIncome} />
      </div>
    </div>
  )
}
